// TRIPWIRE: remove after fix
type GateCheck = { ok: boolean; msg: string; meta?: Record<string, unknown> };

export function gate(label: string, checks: GateCheck[]) {
  const fail = checks.find(c => !c.ok);
  const summary = {
    label,
    ok: !fail,
    failedCheck: fail?.msg ?? null,
    meta: Object.assign({}, ...checks.map(c => c.meta || {})),
    ts: new Date().toISOString(),
  };
  console.log(`[GATE]`, summary);
  return summary;
}
